import { ProjectTaskActionTypes, ProjectTaskActions } from './project-task.actions';
import { IProjectTask } from '../../../../commons';

export interface State {
    error: string | null;
    pending: boolean;
    stateData: IProjectTask | null;
}

export const initialState: State = {
    error: null,
    pending: false,
    stateData: null
};

export function reducer(state = initialState, action: ProjectTaskActions): State {
    switch (action.type) {

        case ProjectTaskActionTypes.LoadProjectTaskState: {
            return {
                ...state,
                error: null,
                pending: false
            };
        }

        case ProjectTaskActionTypes.LoadProjectTaskStateSuccess: {
            return {
                error: null,
                pending: false,
                stateData: action.payload
            };
        }

        case ProjectTaskActionTypes.LoadProjectTaskStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }

        case ProjectTaskActionTypes.ProjectTaskScreenErrorReset: {
            return {
                ...state,
                error: null,
                pending: false
            };
        } 

        default: {
            return state;
        }
    }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getStateData = (state: State) => state.stateData;